import * as Yup from 'yup';

export const initialChangePasswordForm = {
  password: '',
  confirmPassword: '',
};

export const colorDescriptions = {
  1: 'text',
  2: 'buttons',
  3: 'labels',
  4: 'background',
};

export const colorPaletteOptions = [
  {
    label: 'Default Palette',
    value: 'default',
    primaryColors: ['#270438', '#7D3DAE', '#C6009C', '#F7F7F8'],
  },
  {
    label: 'Orange Base Palette',
    value: 'orange',
    primaryColors: ['#242424', '#EF874C', '#353396', '#FFF6F1'],
  },
  {
    label: 'Green Base Palette',
    value: 'green',
    primaryColors: ['#270438', '#5A8F7B', '#355764', '#E2F4ED'],
  },
  {
    label: 'Custom Palette',
    value: 'custom',
  },
];

export const colorList = ['#270438', '#C6009C', '#EF874C', '#F7F7F8'];

export const changePasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required('Current password is required')
    .min(10, 'Password must be at least 10 characters long')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Password must contain at least one numeric character')
    .matches(
      /[@#%&!]/,
      'Password must contain at least one special character like @, #, %, &, or !',
    ),
  confirmPassword: Yup.string()
    .required('Passwords must match')
    .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

export const carouselSchema = Yup.object().shape({
  details: Yup.array().of(
    Yup.object().shape({
      headingText: Yup.string().nullable(),
      paragraphText: Yup.string().nullable(),
    }),
  ),
});

export const bannerSchema = Yup.object().shape({
  details: Yup.array().of(
    Yup.object().shape({
      headingText: Yup.string().nullable(),
    }),
  ),
});

export const productTypeSchema = Yup.object().shape({
  details: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Please enter name').nullable(),
    }),
  ),
});

export const dealsSchema = Yup.object().shape({
  name: Yup.string().required('Please enter heading name').nullable(),
});

export const featuredCategorySchema = Yup.object().shape({
  name: Yup.string().nullable(),
  details: Yup.array().of(
    Yup.object().shape({
      headingText: Yup.string().nullable(),
      url: Yup.string().nullable(),
    }),
  ),
});

export const featuredSchema = Yup.object().shape({
  name: Yup.string().nullable(),
  details: Yup.array().of(
    Yup.object().shape({
      headingText: Yup.string().required('Please enter name').nullable(),
      url: Yup.string().nullable(),
    }),
  ),
});

export const informationTypeSchema = Yup.object().shape({
  extraProps: Yup.object().shape({
    headingText: Yup.string().nullable(),
    descriptionText: Yup.string()
      // .required('Please enter description text')
      .nullable(),
  }),
});

export const serviceTypeSchema = Yup.object().shape({
  name: Yup.string().nullable(),
  details: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().nullable(),
      paragraphText: Yup.string().required('Please enter text').nullable(),
    }),
  ),
});

export const teamSchema = Yup.object().shape({
  // name: Yup.string().required('Please enter heading name').nullable(),
  extraProps: Yup.object().shape({
    title: Yup.string().nullable(),
    teams: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().nullable(),
        designation: Yup.string().nullable(),
      }),
    ),
    paragraph: Yup.array().of(
      Yup.object().shape({
        text: Yup.string().required('Please enter paragraph').nullable(),
      }),
    ),
  }),
});

export const testimonialSchema = Yup.object().shape({
  // name: Yup.string().required('Please enter heading name').nullable(),
  extraProps: Yup.object().shape({
    testimonials: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().nullable(),
        designation: Yup.string().nullable(),
        message: Yup.string()
          .test(
            'len',
            'Description should be max 250 characters',
            (val) => !val?.length || val?.length <= 250,
          )
          .nullable(),
      }),
    ),
  }),
});

export const mapSchema = Yup.object().shape({
  extraProps: Yup.object().shape({
    latitude: Yup.string().required('Please enter latitude').nullable(),
    longitude: Yup.string().required('Please enter longitude').nullable(),
  }),
});

export const addressSchema = Yup.object().shape({
  name: Yup.string().required('Please enter heading name').nullable(),
  extraProps: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().required('Please enter title').nullable(),
      address: Yup.string().required('Please enter address').nullable(),
      phone: Yup.string().required('Please enter phone number').nullable(),
      email: Yup.string().required('Please enter email').nullable(),
    }),
  ),
});

export const contactUsHeading = Yup.object().shape({
  name: Yup.string().required('Please enter heading name').nullable(),
  extraProps: Yup.object().shape({
    headingText: Yup.string().required('Please enter title').nullable(),
    descriptionText: Yup.string().required('Please enter title').nullable(),
    otherInfo: Yup.array().of(
      Yup.object().shape({
        heading: Yup.string().required('Please enter heading').nullable(),
        description: Yup.string()
          .required('Please enter description')
          .nullable(),
      }),
    ),
    paragraphText: Yup.array().of(
      Yup.object().shape({
        text: Yup.string().required('Please enter paragraph').nullable(),
      }),
    ),
  }),
});

export const promotionSchema = Yup.object().shape({
  details: Yup.array().of(
    Yup.object().shape({
      headingText: Yup.string()
        .required('Please enter heading text')
        .nullable(),
      paragraphText: Yup.string()
        .required('Please enter paragraph text')
        .nullable(),
      name: Yup.string().required('Please enter paragraph text').nullable(),
    }),
  ),
});

export const pageNameValidation = Yup.object().shape({
  pageName: Yup.string().required('Name is required'),
});

export const seoBasicsDefaultValues = {
  metaTitle: '',
  keywords: [],
  description: '',
  searchIndex: true,
  robotTags: [],
  ogTitle: '',
  ogDescription: '',
  ogType: '',
  ogUrl: '',
  imageDTO: null,
};

export const socialShareDefaultValues = {
  title: '',
  images: [],
  description: '',
};

export const mapStyleValidationSchema = Yup.object().shape({
  extraProps: Yup.object().shape({
    imageLinkAddress: Yup.string().url('Invalid URL format'),
  }),
});
// Validation schema for another style (if needed)
export const anotherStyleValidationEmptySchema = Yup.object().shape({
  extraProps: Yup.object().shape({}),
});
